const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Ceylia: whole kronor in every currency.
   Shopify's built-in format for market currencies (NOK) is "1.099,00 kr" and can't be changed in admin,
   so every rendered price (theme, Kaching widget, pricing cards) gets ",00"/".00" removed and a space as
   thousands separator. Only writes when the text actually changes, so it never loops with other scripts. */
(function () {
  'use strict';
  var SEL = '.bsw__price, .bsw__compare, .kb-bar-price, .kb-bar-full-price, .mb-atc-btn-price, .mb-atc-btn-compare, [data-pc-price], [data-pc-compare], [data-pc-mobile-price], .price-item, .mcd-price, .mcd-compare, .mcd-total, .mcd-sub, .mcd-save, [class*="kaching-bundles"] [class*="price"], [class*="kaching-bundles"] [class*="subtitle"], [class*="kaching-bundles-sticky-atc"] span, [class*="kaching-bundles-sticky-atc"] div';
  function strip(s) { return String(s).replace(/(\d)[.,]00(?!\d)/g, '$1').replace(/(\d)\.(?=\d{3}(?!\d))/g, '$1 '); }
  var busy = false;
  function clean() {
    if (busy) return; busy = true;
    try {
      document.querySelectorAll(SEL).forEach(function (el) {
        for (var i = 0; i < el.childNodes.length; i++) {
          var n = el.childNodes[i];
          if (n.nodeType === 3) { var t = n.nodeValue, c = strip(t); if (c !== t) n.nodeValue = c; }
        }
      });
    } finally { busy = false; }
  }
  function start() {
    clean();
    new MutationObserver(function () { clean(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();